<template>
  <main class="flex-initial" style="width: 380px" :class="{'xl:block': conversationId}">
    <!-- Primary column -->
    <section aria-labelledby="primary-heading" class="min-w-0 flex-1 h-full flex flex-col lg:order-last">
      <div v-if="this.$root.SocketsReady && !this.$root.sockets.socketAuthenticationError" class="flex-initial text-left conversation-list">
        <ConversationsList :conversationId="conversationId" :requestedDisplayStatusFilter="requestedDisplayStatusFilter" />
      </div>
    </section>
  </main>
  <!-- Secondary column (hidden on smaller screens) -->
  <aside v-if="conversationId && this.$root.SocketsReady && !this.$root.sockets.socketAuthenticationError" class="overflow-x-hidden flex-grow bg-white border-l border-gray-200 overflow-y-auto flex">
    <Conversation v-on:conversation-opened="selectTabForConversation" />
  </aside>
  <aside v-else class="flex-grow border-l border-gray-200 overflow-y-auto text-center hidden xl:block">
    <div class="messages-area relative border-l border-gray-200 flex-grow h-full text-center select-message">
      <div class=" align-middle inline-block relative text-center align-middle">
        <img src="@/assets/conversations.svg" class="inline-block">
        <div class="rounded-2xl max-w-md p-2" style="margin: 0 auto;margin-top: 20px" v-if="this.$root.SocketsReady && !this.$root.sockets.socketAuthenticationError">
          <h3 class="font-bold text-xl">{{ $t('conversation.selectTitle') }}</h3>
          <p class="mt-4">{{ $t('conversation.selectText') }}</p>
        </div>
        <div v-else class="text-center relative">
          <Disconnected />
        </div>
      </div>
    </div>
  </aside>
  <div v-if="this.$root.sockets.socketHardDisconnect && !this.$root.sockets.socketAuthenticationError">
    <DisconnectedModal />
  </div>
</template>

<script>
import ConversationsList from '@/components/conversations/ConversationsList.vue'
import Conversation from '@/components/conversations/Conversation.vue'
import Disconnected from '@/components/conversations/parts/DisconnectedWidget.vue'
import DisconnectedModal from '@/components/page/DisconnectedModal.vue'


export default {
  name: 'ConversationList',
  components: {
    ConversationsList,
    Conversation,
    Disconnected,
    DisconnectedModal,
  },
  methods: {
    selectTabForConversation(status, assignedAgent) {
      if (assignedAgent === this.$root.currentAgent.id && status === 'assigned') {
        this.requestedDisplayStatusFilter = 'currentAgent';
      } else {
        this.requestedDisplayStatusFilter = status;
      }
    },
  },
  data() {
    return {
      requestedDisplayStatusFilter: undefined,
    }
  },
  computed: {
    conversationId: function () {
      return this.$root.RouteArgs[0];
    },
  },
}
</script>
